/**
 * @flow
 * @relayHash 11116f157620a81d9d876cadd4ee6c0a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteGLAccountInput = {|
  id: string
|};
export type DeleteGLAccountMutationVariables = {|
  input: DeleteGLAccountInput
|};
export type DeleteGLAccountMutationResponse = {|
  +deleteGLAccount: {|
    +deletedId: string
  |}
|};
export type DeleteGLAccountMutation = {|
  variables: DeleteGLAccountMutationVariables,
  response: DeleteGLAccountMutationResponse,
|};
*/


/*
mutation DeleteGLAccountMutation(
  $input: DeleteGLAccountInput!
) {
  deleteGLAccount(input: $input) {
    deletedId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteGLAccountInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteGLAccount",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteGLAccountPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteGLAccountMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteGLAccountMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteGLAccountMutation",
    "id": null,
    "text": "mutation DeleteGLAccountMutation(\n  $input: DeleteGLAccountInput!\n) {\n  deleteGLAccount(input: $input) {\n    deletedId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a1e78c07330700c0bcd78ae5527be261';
module.exports = node;
